<div :class="['n-modal-content', wrapperClass]">
  <slot />
</div>